// Helpers i18n canon-compatibles.
//
// Home dérive la locale affichée du segment d'URL `[lang]` (`contexts/language-context.tsx`)
// et garde `lib/translations.ts` comme dictionnaire. Ce module ajoute la surface canon
// (`normalizeLocale`, persistance `localStorage["yesman_locale"]`, `getApiLocale`/`setApiLocale`,
// `resolveKey`) utilisée par `contexts/locale-context.tsx` pour pousser `Accept-Language`
// au backend et accéder aux messages de fallback JSON.

export type Locale = 'fr' | 'en'

/** Type opaque pour les dictionnaires de messages JSON. */
export type Messages = Record<string, unknown>

export const SUPPORTED_LOCALES: Locale[] = ['fr', 'en']
export const DEFAULT_LOCALE: Locale = 'fr'
export const LOCALE_STORAGE_KEY = 'yesman_locale'

export function normalizeLocale(raw: string | null | undefined): Locale {
  const base = (raw ?? '').split(/[-_]/)[0].toLowerCase()
  return (SUPPORTED_LOCALES.includes(base as Locale) ? base : DEFAULT_LOCALE) as Locale
}

/**
 * Résout une clé pointée (`"errors.generic"`) dans un objet de messages.
 * Retourne la clé brute si la valeur n'est pas une string.
 */
export function resolveKey(messages: Messages, key: string): string {
  const value = key.split('.').reduce<unknown>((acc, segment) => {
    if (acc && typeof acc === 'object') return (acc as Record<string, unknown>)[segment]
    return undefined
  }, messages)
  return typeof value === 'string' ? value : key
}

/** Locale à pousser en `Accept-Language` : locale persistée sinon défaut. */
export function getApiLocale(): Locale {
  if (typeof window === 'undefined') return DEFAULT_LOCALE
  return normalizeLocale(localStorage.getItem(LOCALE_STORAGE_KEY))
}

/** Persiste la locale active (source du header `Accept-Language`). */
export function setApiLocale(locale: string): void {
  if (typeof window !== 'undefined') {
    localStorage.setItem(LOCALE_STORAGE_KEY, normalizeLocale(locale))
  }
}
